import React from "react";

const EmptyState = ({ icon, message }) => (
  <div className="text-center text-muted py-3">
    <i className={`${icon} fa-2x mb-2 opacity-50`} />
    <p className="small mb-0">{message}</p>
  </div>
);

export default EmptyState;
